import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { space } from 'styled-system';

import { Flex } from 'common/components/Flex';
import { Link } from 'common/components/Link';
import { HeadlineH3 } from 'common/components/Typography';
import type { BrandsNavProps } from './types';
import { getBrandSectionLink } from './utils';

const Nav = styled.nav``;

const List = styled(Flex)<any>`
  list-style: none;
`;

const listStyles: ComponentProps<typeof List> = {
  as: 'ol',
  p: 'sp_0',
  mt: 'sp_0',
  mb: ['sp_8', null, 'sp_12', 'sp_20'],
  flexWrap: 'wrap',
  justifyContent: 'center',
};

const listItemStyles: ComponentProps<typeof HeadlineH3> = {
  color: 'sys.neutral.text.default',
  as: 'li',
  mb: 'sp_12',
  fontWeight: 'normal',
};

const StyledLink = styled(Link)<any>`
  ${space};
`;

const BrandsNav = ({ brandsSections }: BrandsNavProps) => (
  <Nav>
    <List {...listStyles}>
      {brandsSections.map(({ key }) => (
        <HeadlineH3 {...listItemStyles} key={key}>
          <StyledLink px="sp_8" href={getBrandSectionLink(key)}>
            {key}
          </StyledLink>
        </HeadlineH3>
      ))}
    </List>
  </Nav>
);

export default BrandsNav;
